import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { CashBoxEditorViewModel, CashDeskInserter, CashDeskUpdater } from "../cashBoxEditor/cashBoxEditor-viewModel";
import { ICashBox } from "../ICashBox";
import  { CashBoxManipulationView } from "./cashBoxManipulation-view"

export class CashBoxManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'تعریف صندوق';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.cashboxes = ObservableArray.create<cashbox>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.refresh()

    }
    GetDefaultView(): View <ViewModel> {
        return new CashBoxManipulationView();
    }
    public getTypeId(): string {
        return "VM-56B40185-033B-4DDA-8C39-63B0292C7670"
    }

    public set cashboxes(v: ObservableArray<cashbox>) { this._cashboxes = v; } public get cashboxes(): ObservableArray<cashbox> { return this._cashboxes;} private _cashboxes: ObservableArray<cashbox>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    async refresh(){
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/CashDeskManipulationServices/GetAllCashDesks',{
                FurtherQueryInfo:filteringInformation
            });
            this.cashboxes.update(...result.CashDesks.map(q=>{
                let r = new cashbox(this);
                r.id = q.Id;
                r.name = q.Name;
                r.districtId = q.DistrictId;
                r.districtName = q.DistrictName;
                r.disabled = q.Disabled;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async addNew() {
        let popup = new CashBoxEditorViewModel(this,new CashDeskInserter());
        let result = await this.showPopup(popup);
        if(result!=null){
            this.refresh();
        }
    }
    async edit(cashbox:cashbox){
        let popup = new CashBoxEditorViewModel(this,new CashDeskUpdater());
        cashbox.cloneTo(popup);
        let result = await this.showPopup(popup);
        if(result!=null){
            this.refresh();
        }
    }
}


export class cashbox extends ViewModel implements ICashBox{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:CashBoxManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set disabled(v: boolean) { this._disabled = v; } public get disabled(): boolean { return this._disabled;} private _disabled: boolean;
    private _typedParent:CashBoxManipulationViewModel;
    cloneTo(cashbox: ICashBox) {
        cashbox.id = this.id;
        cashbox.districtId = this.districtId;
        cashbox.disabled = this.disabled;
        cashbox.name = this.name;
    }
    edit(){
        this._typedParent.edit(this);
    }

}